<template>
    <div>
        <div>
            <span class="xbed-sub-title">管家信息账号查看</span>
        </div>

        <div class="xbed-breadcrumb">
        <Breadcrumb>
            <BreadcrumbItem>麗家会</BreadcrumbItem>
            <BreadcrumbItem>管家信息账号查看</BreadcrumbItem>
        </Breadcrumb>
        </div>

        <Tabs class="tabs">
            <TabPane label="管家信息账号列表" name="accountList" ref="accountList">
                <Form @submit.native.prevent="preventSubmit" inline>
                <FormItem prop="account" label="账号：" :label-width="84">
                    <Input type="text" v-model="sendQueryParams.account" :maxlength="20"></Input>
                </FormItem>
                <FormItem prop="userName" label="用户名：" :label-width="84">
                    <Input type="text" v-model="sendQueryParams.userName" :maxlength="20"></Input>
                </FormItem>
                <FormItem prop="isAuth" label="身份验证：" :label-width="84">
                    <Select ref="queryParamsCity" v-model="sendQueryParams.isAuth" style="width:150px;">
                        <Option v-for="item in idType" :key="item.value" :value="item.value">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="isFaceRecognized" label="人脸验证：" :label-width="84">
                    <Select ref="queryParamsCity" v-model="sendQueryParams.isFaceRecognized" style="width:150px;">
                        <Option v-for="item in faceType" :key="item.value" :value="item.value">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="accept" label="状态：" :label-width="84">
                    <Select ref="queryParamsCity" v-model="sendQueryParams.accept" style="width:150px;">
                        <Option v-for="item in statusType" :key="item.value" :value="item.value">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <br>
                <FormItem prop="bindState" label="绑定状态：" :label-width="84">
                    <Select ref="queryParamsCity" v-model="sendQueryParams.isBind" style="width:180px;">
                        <Option v-for="item in bindStateType" :key="item.value" :value="item.value">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="queryAccountListWithKeyword">查询</Button>
                </FormItem>
                </Form>
                <!-- Table-->
                <Table stripe :loading="false" ref="accountListTable" :columns="columns" :data="accountList"></Table>
                <div style="margin: 10px;overflow: hidden">
                    <Page show-sizer placement="top" :total="listCount" :current="listPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
                </div>
            </TabPane>
        </Tabs>

        <!-- Modal -->
        <Modal v-model="detailModal.display" :loading="true"  ref="detailModal" title="图片详情" width="800">
            <Form @submit.native.prevent="preventSubmit" :model="detailModal" ref="detailModalForm" :label-width="170">
                <FormItem label="身份证号：">
                    <span>{{detailModal.cardId}}</span>
                </FormItem>
                <FormItem label="头像照片：">
                    <img :src="detailModal.iconImg" alt="" style="width:100%">       
                </FormItem>
                <FormItem label="身份证正面照片：">
                    <img :src="detailModal.cardFrontImg" alt="" style="width:100%">            
                </FormItem>
                <FormItem label="身份证反面照片：">
                    <img :src="detailModal.cardBackImg" alt="" style="width:100%">            
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="closeDetailModal">关闭</Button>
           </div>
        </Modal>

    </div>
</template>

<script>
import Utils from '../../utils'
import API from "../../api";

export default {
    created() {
        this.token = Utils.findFromLocalStorage("vue-token");
        this.username = Utils.findFromLocalStorage("vue-username");
        this.env = Utils.findFromLocalStorage("env", "dev");
    },
    mounted(){
      this.init()
    },
    data() {
        return {
            idType:[
                {name:'全部',value:-1},
                {name:'未验证',value:0},
                {name:'已验证',value:1},                              
                {name:'待验证',value:2},                              
                {name:'验证不通过',value:3},                              
            ],
            faceType:[
                {name:'全部',value:-1},
                {name:'未验证',value:0},
                {name:'待验证',value:1},                              
                {name:'已验证',value:2},                              
                {name:'验证不通过',value:3},                              
            ],
            statusType:[
                {name:'全部',value:-1},
                {name:'可接单',value:1},
                {name:'不可接单',value:0}    
            ],
            bindStateType:[ // 绑定状态
                {name:'全部',value:-1},
                {name:'已绑定',value:1},
                {name:'未绑定',value:0}    
            ],
            queryParams: {
                url:'/admin/xbCleanertAction/list',
                page:1,
                size:10,
                account:'',
                userName:'',
                isAuth:-1,
                isFaceRecognized:-1,
                accept:-1,
                isBind:-1,
            },
            sendQueryParams: {
                url:'/admin/xbCleanertAction/list',
                page:1,
                size:10,
                account:'',
                userName:'',
                isAuth:-1,
                isFaceRecognized:-1,
                accept:-1,
                bindState:-1,
                isBind:-1
            },
            accountList:[],
            listCount:0,
            listPage:1,
            detailModal:{
                display:false
            },
            columns: [
          {
            title: "ID",
            key: "id",
            align: "center",
            width: 80
          },
          {
            title: "账号",
            key: "account",
            align: "center",
            width: 150
          },
          {
            title: "验证码",
            key: "userPassword",
            align: "center",
            width: 100
          },
          {
            title: "用户名",
            key: "userName",
            align: "center",
            width: 100
          },
          {
            title: "银行名",
            key: "bankName",
            align: "center",
            width: 150
          },
          {
            title: "登记省",
            key: "province",
            align: "center",
            width: 100
          },
          {
            title: "登记市",
            key: "city",
            align: "center",
            width: 100
          },
          {
            title: "登记区",
            key: "district",
            align: "center",
            width: 100
          },
          {
            title: "支行名",
            key: "bankBranchName",
            align: "center",
            width: 150
          },
          {
            title: "卡号",
            key: "bankNo",
            align: "center",
            width: 150
          },
          {
            title: "状态",
            key: "accept",
            align: "center",
            width: 100,
            render: (h, params) => {
              let state = params.row.accept == 1 ? '可接单' : '不可接单';
              return h("div", {}, state);
            }
          },
          {
            title: "协议",
            key: "isAgree",
            align: "center",
            width: 100,
            render: (h, params) => {
              let state = params.row.isAgree == 1 ? '已签订' : '未签订';
              return h("div", {}, state);
            }
          },
          {
            title: "身份验证",
            key: "isAuth",
            align: "center",
            width: 100,
            render: (h, params) => {
            let state = ['未验证','已验证','待验证','验证不通过'][params.row.isAuth]
              return h("div", {}, state);
            }
          },
          {
            title: "人脸验证",
            key: "isFaceRecognized",
            align: "center",
            width: 100,
            render: (h, params) => {
              let state = ['未验证','待验证','已验证','验证不通过'][params.row.isFaceRecognized]
              return h("div", {}, state);
            }
          },
          {
            title: "绑定状态",
            key: "isFaceRecognized",
            align: "center",
            width: 100,
            render: (h, params) => {
              let state = ['未绑','已绑'][params.row.isBind]
              return h("div", {}, state);
            }
          },
          {
            title: "押金(元)",
            key: "deposit",
            align: "center",
            width: 100,
            render: (h,p) =>{
              let deposit = p.row.deposit ? (p.row.deposit/100).toFixed(2) : 0;
              return h('div',{},deposit)
            }
          },
          {
            title: "所属企业",
            key: "landlordName",
            align: "center",
            width: 100
          },
          {
            title: "用户角色",
            key: "role",
            align: "center",
            width: 150
          },
          {
            title: "备注",
            key: "remark",
            align: "center",
            width: 100
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                // h(
                //   "Button",
                //   {
                //     props: {
                //       type: params.row.accept === 1 ? "error" : "success",
                //       size: "small"
                //     },
                //     style: {
                //         marginLeft:'10px'
                //     },
                //     on: {
                //       click: () => {
                //           this.$Modal.confirm({
                //           title: "提示",
                //           content: `确定${params.row.accept === 1 ? '禁止' : '开通'}${params.row.id} - ${params.row.account}吗？\n一经确定将无法修改`,
                //           okText: "确定",
                //           cancelText: "取消",
                //           onOk: () => {
                //             this.toggleAccept({
                //                 accept:params.row.accept,
                //                 id:params.row.id
                //             })
                //           }
                //         });
                //       }
                //     }
                //   },
                //   params.row.accept === 1 ? '禁止接单' : '开通接单'
                // ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.isWatcher === 1 ? "error" : "success",
                      size: "small"
                    },
                    style: {
                        marginLeft:'10px'                        
                    },
                    on: {
                      click: () => {
                          this.$Modal.confirm({
                          title: "提示",
                          content: `确定${params.row.isWatcher === 1 ? '禁止' : '开通'}${params.row.id} - ${params.row.account}吗？\n一经确定将无法修改`,
                          okText: "确定",
                          cancelText: "取消",
                          onOk: () => {
                            this.toggleWatcher({
                                isWatcher:params.row.isWatcher,
                                id:params.row.id
                            })
                          }
                        });
                      }
                    }
                  },
                   params.row.isWatcher === 1 ? '禁止查房' : '开通查房'
                ),
                // h(
                //   "Button",
                //   {
                //     props: {
                //       type: "info",
                //       size: "small"
                //     },
                //     style: {
                //         marginLeft:'-12px'
                //     },
                //     on: {
                //       click: () => {
                //           this.openDetailModal({
                //               cardId:params.row.cardId,
                //               cardFrontImg:params.row.cardFrontImg,
                //               cardBackImg:params.row.cardBackImg,
                //               headImg:params.row.headImg,                              
                //           })
                //       }
                //     }
                //   },
                //   "更多详情"
                // ),
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                        marginLeft:'10px',
                    },
                    on: {
                      click: () => {
                          if(this.$router){
                            window.open(`#/app/cleaner/housekeeperAccountEdit?id=${params.row.id}`)       
                         }else{
                            window.open(`#/Cleaner/Cleaner/cleanerAccountEdit?id=${params.row.id}`);
                         }
                      }
                    }
                  },
                  "修改"
                )
              ]);
            }
          }
        ]
        }
    },
    methods : {
        async init(){
          this.queryAccountList()
        },
        async queryAccountList () {
            this.queryParams.isBind = this.queryParams.isBind == -1 ? '':this.queryParams.isBind
            let resp = (await API.omsAPI[this.env].cleaner.xbedCleanApi(this.queryParams,this.token)).data
            //  let resp = (await API.omsAPI[this.env].cleaner.queryCleanerList(this.queryParams,this.token)).data
            console.info(resp)
            this.listCount = resp.totalCount                    
            this.accountList = resp.content || [];
        },
        queryAccountListWithKeyword () {
            this.queryParams = Object.assign({}, this.sendQueryParams);
            this.queryAccountList()
        },
        changePage(pageIndex) {
          this.listPage = pageIndex;
          this.queryParams.page = pageIndex
          this.queryAccountList();
        },
        changePageSize(pageSize){
            this.queryParams.size = pageSize
            this.queryAccountList();
        },
        async toggleAccept (accept = {}) {
            let params = {
                accept:accept.accept === 0 ? 1 : 0,
                id:accept.id,
                updateName:this.username
            }
            let resp = (await API.omsAPI[this.env].cleaner.acceptCleaner(params,this.token)).data
            if(resp.retCode) {
                this.$Notice.error({
                    desc: resp.msg 
                 })
            } else {
                  this.$Notice.success({
                    desc: '操作成功'
                 })  
                 this.queryAccountList()
            }
        },
        async toggleWatcher (watcher = {}) {
            let params = {
                isWatcher:watcher.isWatcher === 0 ? 1 : 0,
                id:watcher.id,
                updateName:this.username
            }
            let resp = (await API.omsAPI[this.env].cleaner.watcherCleaner(params,this.token)).data
            if(resp.retCode) {
                this.$Notice.error({
                    desc: resp.msg
                 })
            } else {
                  this.$Notice.success({
                    desc: '操作成功'
                 })  
                 this.queryAccountList()
            }
        },
        // openDetailModal( detail = {} ){
        //     // 初始化modal
        //     this.detailModal = Object.assign(this.detailModal,{
        //         display:true,
        //     },detail)
        //     console.info(this.detailModal)
        // },
        closeDetailModal () {
            this.detailModal.display = false
        },
        preventSubmit() {
            return false;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/cleaner/account-list.vue